let isInitialized = false;
let initializationPromise = null;
let isReinitializing = false;

const initialize = () => {
  if (initializationPromise) {
    return initializationPromise;
  }

  initializationPromise = new Promise(resolve => {
    const checkOneTrust = () => {
      if (typeof window !== 'undefined' && window.OneTrust) {
        // Wait a bit more to ensure OneTrust is fully loaded
        setTimeout(() => {
          isInitialized = true;
          resolve();
        }, 200);
      } else {
        // Retry after a short delay
        setTimeout(checkOneTrust, 100);
      }
    };

    checkOneTrust();
  });

  return initializationPromise;
};

const showSettings = () => {
  return initialize().then(() => {
    if (typeof window !== 'undefined' && window.OneTrust) {
      const methods = [
        'ToggleInfoDisplay',
        'Show',
        'ShowInfoDisplay',
        'ShowPreferences',
        'OpenPreferences',
      ];

      for (const method of methods) {
        if (window.OneTrust[method]) {
          try {
            window.OneTrust[method]();
            return; // Exit if successful
          } catch (error) {
            console.error('Error calling OneTrust method:', error);
          }
        }
      }

      // Fallback: try triggering the original button click
      const originalButton = document.getElementById('ot-sdk-btn');
      if (originalButton) {
        try {
          originalButton.click();
        } catch (error) {
          console.error('Error clicking original button:', error);
        }
      }
    }
  });
};

// Reinitialize OneTrust (useful for route changes)
const reinitialize = () => {
  // Prevent multiple simultaneous reinitializations
  if (isReinitializing) {
    return;
  }

  isReinitializing = true;

  if (typeof window !== 'undefined' && window.OneTrust) {
    // Only call OnConsentChanged if it exists and we're not in the middle of initialization
    if (window.OneTrust.OnConsentChanged && isInitialized) {
      try {
        // Call with a proper callback function to avoid the undefined error
        window.OneTrust.OnConsentChanged(() => {});
      } catch (error) {
        console.error('Error calling OnConsentChanged:', error);
      }
    }
  }

  // Reset the flag after a delay
  setTimeout(() => {
    isReinitializing = false;
  }, 1000);
};

// Check if OneTrust is ready
const isReady = () => {
  return typeof window !== 'undefined' && window.OneTrust && isInitialized;
};

// Export the public API
const oneTrustManager = {
  initialize,
  showSettings,
  reinitialize,
  isReady,
};

export default oneTrustManager;
